/* PDP 2026 behaviour. Kept in its own file, loaded from main-product.liquid,
   so it cannot be taken out by an unrelated top-level error in product.js. */
(function () {
  // Click & Collect buttons live inside the store-availability modal (one per store).
  // On click: close the modal, then add the selected variant + open the cart using the
  // theme's own add-to-cart flow (which re-renders and opens the cart drawer).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.jpdp-cc') : null;
    if (!btn) return;
    e.preventDefault();
    var close = document.querySelector('.side-panel-wrapper [close-side-panel]');
    if (close) close.click();
    var atc = document.querySelector('#AddToCart') || document.querySelector('product-form button[name="add"]');
    if (atc) atc.click();
  });
})();
